var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHairlossProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 109,
    viewBox: "0 0 107 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.539062,
    width: 105.554,
    height: 108.924,
    rx: 32.5647,
    fill: "#C3A9FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.539062,
    width: 105.554,
    height: 108.924,
    rx: 32.5647,
    fill: "url(#paint0_radial_6841_62594)",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.539062,
    width: 105.554,
    height: 108.924,
    rx: 32.5647,
    fill: "url(#paint1_radial_6841_62594)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3484 27.3359C43.0389 27.3359 33.7053 31.5147 26.9492 38.271L38.4122 49.7341C42.2348 45.9115 47.5154 43.5473 53.3484 43.5473V27.3359Z",
    fill: "#6435C7",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0156 64.6728H32.2269C32.2269 58.8398 34.591 53.5591 38.4136 49.7365L26.9506 38.2734C20.1943 45.0296 16.0156 54.3633 16.0156 64.6728Z",
    fill: "#6435C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3477 27.3359V43.5473C59.1806 43.5473 64.4613 45.9115 68.2838 49.7341L79.7468 38.271C72.9907 31.5147 63.6571 27.3359 53.3477 27.3359Z",
    fill: "#FFA500",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7462 38.2734L68.2832 49.7365C72.1056 53.5591 74.4699 58.8398 74.4699 64.6728H90.6812C90.6812 54.3633 86.5023 45.0296 79.7462 38.2734Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8807 81.6346C45.4152 81.6346 41.8825 80.8798 39.6331 79.136C38.7725 78.4567 37.1345 79.7248 35.7607 77.8603C33.9264 75.3769 34.568 72.833 35.8286 72.1536C37.3383 71.3384 38.6517 73.067 38.6517 73.067C36.4249 60.4534 41.5579 52.6406 52.8807 52.6406C64.2034 52.6406 69.3364 60.4534 67.1096 73.067C67.1096 73.067 68.4305 71.3384 69.9327 72.1536C71.1933 72.833 71.8349 75.3769 70.0006 77.8603C68.6268 79.7248 66.9812 78.4567 66.1283 79.136C63.8788 80.9024 60.3461 81.6346 52.8807 81.6346Z",
    fill: "#FFE2C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8807 81.6346C45.4152 81.6346 41.8825 80.8798 39.6331 79.136C38.7725 78.4567 37.1345 79.7248 35.7607 77.8603C33.9264 75.3769 34.568 72.833 35.8286 72.1536C37.3383 71.3384 38.6517 73.067 38.6517 73.067C36.4249 60.4534 41.5579 52.6406 52.8807 52.6406C64.2034 52.6406 69.3364 60.4534 67.1096 73.067C67.1096 73.067 68.4305 71.3384 69.9327 72.1536C71.1933 72.833 71.8349 75.3769 70.0006 77.8603C68.6268 79.7248 66.9812 78.4567 66.1283 79.136C63.8788 80.9024 60.3461 81.6346 52.8807 81.6346Z",
    fill: "url(#paint2_radial_6841_62594)",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.878 62.5279C49.6774 62.5279 47.4204 61.8787 44.7634 62.3845C43.7756 62.5948 42.8844 63.124 42.227 63.8905C41.5695 64.6571 41.1823 65.6185 41.125 66.6268C41.276 63.5621 42.4837 60.2256 44.7634 59.501C45.1457 59.3739 45.5456 59.3077 45.9485 59.3047C48.6584 59.3047 50.0624 62.5279 52.878 62.5279Z",
    fill: "#FFE2C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9916 59.5C63.2561 60.2549 64.479 63.5612 64.6375 66.6259C64.576 65.6178 64.1864 64.6574 63.5281 63.8914C62.8698 63.1255 61.979 62.5959 60.9916 62.3836C58.327 61.8778 56.0775 62.527 52.877 62.527C56.0775 62.527 57.4513 58.3678 60.9916 59.5Z",
    fill: "#FFE2C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4927 53.4219C58.4323 54.758 55.9413 55.8299 52.8766 55.8299C49.8119 55.8299 47.3285 54.758 47.2681 53.4219C39.9159 55.6864 36.8361 62.7745 38.6553 73.0481C38.7308 72.9424 38.8138 72.8443 38.8968 72.7386C40.097 71.2289 40.867 69.8475 41.1236 66.6092C41.2746 63.5445 42.4824 60.208 44.762 59.4834C45.1443 59.3563 45.5442 59.2901 45.9471 59.2871C48.657 59.2871 50.061 62.5103 52.8766 62.5103C56.0772 62.5103 57.451 58.3511 60.9913 59.4909C63.2558 60.2458 64.4787 63.552 64.6372 66.6167C64.8863 69.8551 65.6562 71.2138 66.8564 72.7462L67.1055 73.0557C68.9247 62.7745 65.8374 55.6864 58.4927 53.4219Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.88 55.8261C55.9447 55.8261 58.4357 54.7542 58.4961 53.4181C54.8264 52.3815 50.9412 52.3815 47.2715 53.4181C47.3319 54.7542 49.8153 55.8261 52.88 55.8261Z",
    fill: "#FFE2C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6841_62594",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3936 22.6924) rotate(51.9213) scale(90.328 89.6933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6841_62594",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.6337 95.3083) rotate(-93.5572) scale(93.2186 100.707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6841_62594",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2572 58.681) rotate(44.476) scale(27.0145 27.6225)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairlossProgress);
export default __webpack_public_path__ + "static/media/hairlossProgress.686508bf.svg";
export { ForwardRef as ReactComponent };